
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[office]/[game]",
      function () {
        return require("private-next-pages/[office]/[game]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[office]/[game]"])
      });
    }
  